<template>
  <div class="checkout-panel-title">
    <div style="width: 3rem">
      <h5>{{ index }}</h5>
    </div>
    <div style="margin-right: 2rem">
      <h5>{{ title }}</h5>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    index: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.checkout-panel-title {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  text-align: left;
  width: 240px;
}

.checkout-panel-title div {
  display: inline-block;
  padding: 1rem;
}
</style>
